import React, { FC } from "react";
import { QuestionProps } from "../../../pages/form";
import { LocalDateInput } from "./components/local-date-input";
import { Maybe } from "graphql/jsutils/Maybe";
import {
  Core_LocalDateMsg,
  Core_LocalTimeMsg,
} from "../../../src/generated/graphql";
import { Col, Row } from "antd";
import { LocalTimeInput } from "./components/local-time-input";

export const LocalDateTimeQuestion: FC<QuestionProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const localDateTimeQuestion = question?.localDate;
  const localDateTimeValue = answer?.value?.localDateTime?.value;

  const localDateValue = localDateTimeValue?.date;
  const localTimeValue = localDateTimeValue?.time;

  function answerDateQuestion(value: Maybe<Core_LocalDateMsg> | undefined) {
    onAnswer({
      localDateTime: { value: { date: value } },
    });
  }

  function answerTimeQuestion(value: Maybe<Core_LocalTimeMsg> | undefined) {
    onAnswer({
      localDateTime: { value: { time: value } },
    });
  }

  return (
    <Row gutter={16}>
      <Col xs={24} lg={12}>
        <LocalDateInput value={localDateValue} onChange={answerDateQuestion} />
      </Col>
      <Col xs={24} lg={12}>
        <LocalTimeInput value={localTimeValue} onChange={answerTimeQuestion} />
      </Col>
    </Row>
  );
};
